import {
  queryOptions,
  useQuery,
  useSuspenseQuery,
} from "@tanstack/react-query";
import { fetchHealthScore } from "../api/enterpriseClient";

export const healthScoreQueryOptions = (customerId: number) =>
  queryOptions({
    queryKey: ["enterprise-health-score", customerId],
    queryFn: () => fetchHealthScore(customerId),
    staleTime: 60_000,
    retry: 2,
  });

export function useGetHealthScore(customerId: number) {
  return useSuspenseQuery(healthScoreQueryOptions(customerId));
}

export function useHealthScoreQuery(customerId: number) {
  return useQuery(healthScoreQueryOptions(customerId));
}
